// API service for insurance management
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

class InsuranceService {
  // Get all insurances
  static async getAllInsurances(token, limit = 50, lastKey = null) {
    try {
      let url = `${API_BASE_URL}/insurances?limit=${limit}`;
      if (lastKey) {
        url += `&lastKey=${encodeURIComponent(JSON.stringify(lastKey))}`;
      }

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return {
        insurances: data.data,
        pagination: data.pagination
      };
    } catch (error) {
      console.error('Error fetching insurances:', error);
      throw error;
    }
  }

  // Get insurance by ID
  static async getInsuranceById(insuranceId, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/insurances/${insuranceId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error fetching insurance:', error);
      throw error;
    }
  }

  // Create new insurance
  static async createInsurance(insuranceData, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/insurances`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(insuranceData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error creating insurance:', error);
      throw error;
    }
  }

  // Update insurance
  static async updateInsurance(insuranceId, insuranceData, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/insurances/${insuranceId}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(insuranceData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error updating insurance:', error);
      throw error;
    }
  }

  // Delete insurance
  static async deleteInsurance(insuranceId, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/insurances/${insuranceId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error deleting insurance:', error);
      throw error;
    }
  }

  // Search insurances
  static async searchInsurances(query, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/insurances/search?query=${encodeURIComponent(query)}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error searching insurances:', error);
      throw error;
    }
  }

  // Get insurance statistics
  static async getInsuranceStats(token) {
    try {
      const response = await fetch(`${API_BASE_URL}/insurances/stats`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error fetching insurance stats:', error);
      throw error;
    }
  }
}

export default InsuranceService;
